import { render, staticRenderFns } from "./VrsteTroskovaVozila.vue?vue&type=template&id=0cf1d09d&scoped=true&"
import script from "./VrsteTroskovaVozila.vue?vue&type=script&lang=ts&"
export * from "./VrsteTroskovaVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1d09d",
  null
  
)

export default component.exports